// global feature flags
module.exports = {
  FAVICONS: {
    flag: 'cs-favicons',
    enabled: 'enabled',
    disabled: 'disabled',
  },
  PRIVACY_PROXY: {
    flag: 'sea-privacy-proxy',
    enabled: 'st_cloudflare',
    disabled: 'st_control',
  },
  PRIVACY_PROXY_MS: {
    flag: 'sea-privacy-proxy-ms',
    enabled: 'st_cloudflare',
    disabled: 'st_control',
  },
  SEARCH_SHORTCUTS: {
    flag: 'cs-460-shortcuts',
    variant_a: 'st_ab_shortcuts_a',
    variant_b: 'st_ab_shortcuts_b',
    variant_c: 'st_ab_shortcuts_c',
    control_1: 'st_ab_shortcuts_ctrl1',
    control_2: 'st_ab_shortcuts_ctrl2',
  },
  TOURS_ACTIVITIES_AD_FORMAT: {
    flag: 'cs-567-tours-activities',
    enabled: 'enabled',
    disabled: 'disabled',
  },
  PERSONAL_COUNTER_USER_ONBOARDING: {
    flag: 'jo-personal-counter-user-onboarding-experiment',
    enabled: 'enabled',
    disabled: 'disabled',
  },
  AD_BLOCK_NOTICE: {
    flag: 'cs-326-ad-block-notice',
    enabled: 'enabled',
    disabled: 'disabled',
  },
};
